// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"dd791ffa","55":"b3e81905","126":"5ff34035","171":"22d0277f","432":"647251d3","453":"f4fc3f91","812":"78c8856d","908":"4fadde42"}[chunkId] + ".chunk.js";
};